<template>
  <div class="snackbar" :class="[{ show: value }, type]">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'snackbar',
  props: ['value', 'type'],
};
</script>

<style lang="scss" scoped>
.snackbar {
  position: fixed;
  top: 16px;
  right: 16px;
  color: white;
  background: color('text');
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 32px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
  transform: translateY(-100%);
  opacity: 0;
  transition: all 200ms ease-in-out;
  pointer-events: none;

  &.show {
    opacity: 1;
    transform: translateY(0);
    z-index: 1200;
  }

  &:after {
    content: '';
    width: 100%;
    display: block;
    top: 0;
    position: absolute;
    height: 4px;
    background: color('denotive', 'success');
    left: 0;
  }

  &.error {
    color: color('denotive', 'error');

    &:after {
      background: color('denotive', 'error');
    }
  }
}
</style>
